import React from "react";

/* change_brand — cambio de marca (solo campañas pendientes). */
export default function BrandProposal({ payload, t }) {
  return (
    <div className="chatbot-proposal-body">
      <p className="chatbot-proposal-reason">{t("ChatbotProposalBrand")}</p>
      <span className="chatbot-proposal-new-value">{payload.brand_name}</span>
    </div>
  );
}
